export default __webpack_public_path__ + "static/media/Apple_download.bf879409.png";